/* MobiContext — lightweight React Context so any page can tell the global
 * Mobi avatar what the user is currently doing. Mobi prepends this hint to
 * the LLM system prompt, so answers become page-aware.
 *
 * Usage:
 *   const { setMobiContext } = useMobi();
 *   useEffect(() => {
 *     setMobiContext({
 *       page: "whiteboard",
 *       title: "Physics whiteboard",
 *       hint: "The teacher is drawing a circuit diagram with the battery-bulb prop.",
 *       data: { subject: "Physics", selectedProp: "circuit-bulb" },
 *     });
 *     return () => setMobiContext(null);
 *   }, [subject]);
 */
import React, { createContext, useContext, useMemo, useState } from "react";

const MobiCtx = createContext({ ctx: null, setMobiContext: () => {} });

export const MobiProvider = ({ children }) => {
  const [ctx, setCtx] = useState(null);
  const value = useMemo(() => ({ ctx, setMobiContext: setCtx }), [ctx]);
  return <MobiCtx.Provider value={value}>{children}</MobiCtx.Provider>;
};

export const useMobi = () => useContext(MobiCtx);
